module.exports = __webpack_public_path__ + "img/footer-link-04.a497a9da.png";